var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser01Filled = function SvgUser01Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.87 10.313q-1.298-1.298-1.298-3.13t1.298-3.13T12 2.755q1.83 0 3.13 1.298 1.297 1.299 1.297 3.13 0 1.832-1.298 3.13Q13.832 11.61 12 11.61q-1.83 0-3.13-1.298M2.512 21.245v-2.813q0-.93.504-1.72a3.37 3.37 0 0 1 1.35-1.218 18.4 18.4 0 0 1 3.784-1.38 16.4 16.4 0 0 1 7.7 0q1.908.46 3.784 1.38.844.426 1.349 1.217a3.14 3.14 0 0 1 .505 1.721v2.813z"
  })));
};
export default SvgUser01Filled;